import 'babel-polyfill';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import App from './features/app';
import AuthContext from './features/app/AuthContext';
import 'utils/Date';
import { ErrorBoundary } from 'react-error-boundary';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from './styles/MUITheme';
import { ClickStreamProvider } from 'features/shared/ClickStream';
import AdvertisementPopupContext from 'features/shared/AdvertisementPopup/AdvertisementPopupContext';
import { OnboardingContextProvider } from 'features/shared/Onbording/OnboardingContext';
import './index.css';
import * as am4core from '@amcharts/amcharts4/core';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import dayjs from 'dayjs';
import SurveysContext from 'features/surveys/SurveysContext';
import MunicipalityTasksContext from 'features/mainPage/components/MunicipalityTasks/MunicipalityTasksContext';
import GratitudesContext from 'features/gratitudes/GratitudesContext';
import ConfiguratorsContext from 'hooks/useConfiguratorsContext';
import { createBrowserHistory } from 'history';
import { PageLoaderContextProvider } from 'stores/pageLoaderContext';
import { Error500Page } from 'pages/error';
import MiniSurveyContext from 'features/mainPage/components/MiniSurvey/MiniSurveyContext';
export const history = createBrowserHistory({
  basename: process.env.REACT_APP_BASEURL,
});

am4core.useTheme(am4themes_animated);
am4core.options.commercialLicense = true;

dayjs.locale('ru');

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <Router history={history}>
        <ErrorBoundary fallbackRender={Error500Page}>
          <PageLoaderContextProvider>
            <AuthContext>
              <ClickStreamProvider>
                <SurveysContext>
                  <GratitudesContext>
                    <ConfiguratorsContext>
                      <AdvertisementPopupContext>
                        <MiniSurveyContext>
                          <MunicipalityTasksContext>
                            <App />
                          </MunicipalityTasksContext>
                        </MiniSurveyContext>
                      </AdvertisementPopupContext>
                    </ConfiguratorsContext>
                  </GratitudesContext>
                </SurveysContext>
              </ClickStreamProvider>
            </AuthContext>
          </PageLoaderContextProvider>
        </ErrorBoundary>
      </Router>
    </ThemeProvider>,
    document.getElementById('root'),
  );
});
